import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface TradePayablesInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function TradePayablesInternalControls({ onBack, setActiveSection, controlsListSection }: TradePayablesInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Trade Payables"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

